document.addEventListener("DOMContentLoaded", function () {
    const videos = document.querySelectorAll(".video");
    if (!videos.length) return;

    function youtube_parser(url) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[7].length === 11) ? match[7] : false;
    }

    for (const video of videos) {
        const playButton = video.querySelector(".video__play");
        const thumbnail = video.querySelector(".video__thumbnail");
        const iframe = video.querySelector("iframe");

        if (!playButton || !thumbnail || !iframe) continue;

        const videoUrl = iframe.getAttribute("src");
        const clipId = youtube_parser(videoUrl);
        iframe.setAttribute("allow", "accelerometer; gyroscope; autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share;");
        if ( clipId )
            iframe.setAttribute("src", `https://www.youtube.com/embed/${clipId}?feature=oembed&amp;enablejsapi=1&amp;origin=${window.location.origin}`);

        playButton.addEventListener("click", (e) => {
            e.preventDefault();

            if (clipId) {
                const newSrc = `https://www.youtube.com/embed/${clipId}?modestbranding=1&autoplay=1`;
                iframe.setAttribute("src", newSrc);
            }

            thumbnail.style.transition = "opacity 0.3s ease";
            thumbnail.style.opacity = "0";
            thumbnail.style.pointerEvents = "none";

            setTimeout(() => {
                thumbnail.remove();
            }, 300);
        });
    }
});